import { UploadFieldConfigResponse } from './upload-field-config-response';

export class HisUploadConfiguration {

    /** allows the upload of more than one files if true, exactly one if false or undefined */
    readonly multiple: boolean;

    /** a i18n key for specifying a label at the on the enclosing PLAM */
    readonly label: string;

    readonly required!: boolean;

    readonly readonly: boolean;

    /** a i18n key for the plam helptext icon */
    readonly helptextIcon: string;

    /** the helptext above the file upload field */
    readonly helptextAbove: string;

    /** the helptext below the file upload field */
    readonly helptextBelow: string;

    /** Maximum number of files that can be uploaded. */
    readonly fileLimit: number;

    /** Maximum file size allowed in bytes. */
    readonly maxFileSize: number;

    /**  Ein Merge aus eventuell vorhandenen Dateierweiterungen z. B. *.png und/oder Content Types/mimetypes, z. B. accept */
    readonly accept: string;

    /** shows the category as readonly if true */
    readonly showCategoryIfUnique: boolean;

    readonly showDescription: boolean;

    /** the document metadata ids */
    readonly documentMetadataCategoryIds: number[] = [];

    readonly configKey!: string;

    readonly css: string;

    readonly uploadForLargeFiles!: boolean;

    /** the allowed source types for selecting files */
    readonly sourceTypes: string[] = [];

    /** the allowed local media categories */
    readonly localMediaCategories: string[] = [];

    constructor( response: UploadFieldConfigResponse ) {
        if(!response.configKey) {
            throw new Error('response.confKey must not be null or undefined');
        }

        this.configKey = response.configKey;
        this.fileLimit = response.fileLimit;
        this.label = response.label;
        this.multiple = response.multipleUpload;
        this.maxFileSize = response.sizeLimit;
        this.showDescription = response.allowComment;
        this.helptextAbove = response.helptextAbove;
        this.helptextBelow = response.helptextBelow;
        this.helptextIcon = response.helptextIcon;
        this.showCategoryIfUnique = response.showCategoryIfUnique;
        this.accept = response.accept?.includes( '.*' ) ? null : response.accept;
        this.readonly = response.readonly;
        this.css = response.css;

        this.documentMetadataCategoryIds =
            response.documentMetadataCategoryIds ? Array.from(response.documentMetadataCategoryIds) : [];

        this.sourceTypes = response.sourceTypes ? Array.from(response.sourceTypes) : [];

        this.localMediaCategories = response.localMediaCategories ? Array.from(response.localMediaCategories) : [];

        this.required = response.required ?? false;
        this.uploadForLargeFiles = response.uploadForLargeFiles ?? false;
    }
}
